<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.2017 13.1161C13.9574 11.8249 10.2126 14.401 10.2895 17.8946C10.2818 22.4183 15.8176 24.7061 19.0133 21.5097C21.6403 18.948 20.6115 14.3609 17.2017 13.1161ZM15.0915 17.5015H15.7045C17.388 17.5372 17.4641 19.988 15.7909 20.1304C15.791 20.1304 15.791 20.4212 15.791 20.4212C15.791 20.6374 15.6141 20.8142 15.398 20.8142C15.1819 20.8142 15.005 20.6374 15.005 20.4212V20.1344H14.168C13.6517 20.124 13.6514 19.3561 14.168 19.3485C14.168 19.3485 15.7045 19.3485 15.7045 19.3485C16.4024 19.3357 16.4019 18.2974 15.7045 18.2875H15.0915C13.408 18.2518 13.3319 15.801 15.0051 15.6585C15.005 15.6585 15.005 15.3678 15.005 15.3678C15.005 15.1516 15.1819 14.9748 15.398 14.9748C15.6141 14.9748 15.7909 15.1516 15.7909 15.3678V15.6546H16.628C17.1443 15.665 17.1446 16.4329 16.6279 16.4405H15.0915C14.3935 16.4533 14.3941 17.4916 15.0915 17.5015Z"
      :fill="
        currentScreen === tabRoutes.LOANS
          ? 'var(--main-color)'
          : 'var(--white-color)'
      "
    />
    <path
      d="M8.33255 13.1986C8.95421 13.1682 9.61716 13.1726 10.2266 13.2183C10.6982 13.2536 11.154 13.3204 11.5941 13.403C11.7827 13.2418 11.9792 13.0886 12.1953 12.951C13.1424 12.3302 14.2545 12.004 15.4059 12.004C16.2098 11.9982 17.0351 12.1737 17.7676 12.4952C18.7771 11.2388 19.3308 9.69438 19.3276 8.07047C19.3415 1.90663 11.8435 -1.32045 7.38546 2.93849C4.41491 5.64979 4.49429 10.6518 7.46418 13.2733C7.81777 13.2301 8.12034 13.2104 8.33255 13.1986ZM15.398 10.3575C15.3424 12.251 12.9337 12.2464 12.8791 10.3575C12.9353 8.46328 15.3413 8.4595 15.398 10.3575ZM13.834 4.54953C14.1 4.10859 14.7662 4.48669 14.5138 4.94251C14.5138 4.9425 10.6746 11.5914 10.6746 11.5914C10.4093 12.0357 9.74269 11.6479 9.99478 11.1984C9.99477 11.1984 13.834 4.54953 13.834 4.54953ZM10.372 4.35305C12.034 4.41301 12.0298 7.15925 10.372 7.21773C8.7083 7.16015 8.70492 4.41147 10.372 4.35305Z"
      :fill="
        currentScreen === tabRoutes.LOANS
          ? 'var(--main-color)'
          : 'var(--white-color)'
      "
    />
    <path
      d="M10.372 6.43184C10.9893 6.40789 10.9927 5.16418 10.372 5.13901C9.74779 5.15597 9.75149 6.41642 10.372 6.43184Z"
      :fill="
        currentScreen === tabRoutes.LOANS
          ? 'var(--main-color)'
          : 'var(--white-color)'
      "
    />
    <path
      d="M13.665 10.3575C13.6857 11.2018 14.5937 11.2051 14.6121 10.3575C14.5869 9.50188 13.6923 9.50556 13.665 10.3575Z"
      :fill="
        currentScreen === tabRoutes.LOANS
          ? 'var(--main-color)'
          : 'var(--white-color)'
      "
    />
    <path
      d="M10.1441 20.5666C9.46207 20.7285 8.69959 20.6229 8.00246 20.606C6.77513 20.5145 5.4337 20.276 4.38327 19.6668C4.23788 19.5803 4.11215 19.4899 4.00211 19.3995V19.8593C4.00211 21.1482 6.57207 21.8241 9.11061 21.8241C9.73543 21.8241 10.3406 21.7848 10.9065 21.7101C10.6002 21.3618 10.352 20.9784 10.1441 20.5666Z"
      :fill="
        currentScreen === tabRoutes.LOANS
          ? 'var(--main-color)'
          : 'var(--white-color)'
      "
    />
    <path
      d="M4.78804 18.9948C5.80236 19.57 7.1205 19.769 8.30111 19.8358C8.79678 19.8652 9.33713 19.8669 9.83367 19.8436C9.82581 19.8161 9.814 19.7886 9.80616 19.7611C9.69539 19.4367 9.59629 19.0389 9.55466 18.6726C9.40787 18.6801 9.26131 18.6807 9.11061 18.6805C6.91672 18.6384 5.22644 18.3474 4.0021 17.4309C4.00131 18.0807 3.92391 18.4425 4.78804 18.9948Z"
      :fill="
        currentScreen === tabRoutes.LOANS
          ? 'var(--main-color)'
          : 'var(--white-color)'
      "
    />
    <path
      d="M4.78802 17.0261C5.79216 17.6448 7.81236 17.9507 9.50356 17.8866C9.49597 16.7524 9.82596 15.6532 10.4506 14.684C10.5901 14.4729 10.7366 14.276 10.9025 14.0828C10.3096 13.9995 9.72571 13.9659 9.11059 13.9649C7.07618 13.9153 4.01081 14.5812 4.01002 15.8512C3.96058 16.33 4.27437 16.7131 4.78802 17.0261Z"
      :fill="
        currentScreen === tabRoutes.LOANS
          ? 'var(--main-color)'
          : 'var(--white-color)'
      "
    />
  </svg>
</template>

<script setup>
import {computed} from 'vue';
import {useStore} from 'vuex';

import {tabRoutes} from '@/routes';

const store = useStore();

const currentScreen = computed(() => store.getters['tab/screen']);
</script>
